import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/formDataReport'
import Component from 'components/Reports/FormDataReport'

export default createListViewContainer({ actions, selectors: selectors.formDataReport })(Component)
